import React, { useState } from "react";
import { Modal, Button, Form, Space, Result, Select, DatePicker } from "antd";
import { useStepsForm } from "sunflower-antd";

import { SelectProps } from "antd/lib/select";

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleCancel?: Function | undefined;
  memberId: any;
}

const cancelReasons: SelectProps["options"] = [
  {
    name: "Cancel by policyholder",
    label: "Cancel by policyholder",
    value: "Cancel by policyholder",
  },
  {
    name: "Cancel by insurer",
    label: "Cancel by insurer",
    value: "Cancel by insurer",
  },
];

const CancelPolicyModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handleCancel,
  memberId,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    formProps,
    submit,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);
      if (handleCancel != undefined) {
        const response = await handleCancel(memberId, values);

        if (response.success) {
          setLoading(false);
          return true;
        }
        setErrorMsg(response.message);
        setLoading(false);
        return false;
      }
    },
    total: 3,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const display: any = {
    0: (
      <>
        <Form.Item
          name="LapsedDate"
          label="Cancel Date"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker
            id="CancelDate"
            placeholder="Cancel Date"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item name="LapsedReason" label="Cancel Reason">
          <Select
            id="CancelReason"
            options={cancelReasons}
            size="large"
            style={{ width: "100%" }}
            placeholder="Cancel Reason"
          />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Button
              loading={loading}
              style={{ marginBottom: 10 }}
              block
              size="large"
              onClick={() => {
                submit().then((result: any) => {
                  if (result) {
                    gotoStep(current + 1);
                  } else if (!result) {
                    gotoStep(current + 2);
                  }
                });
              }}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </>
    ),
  };

  return (
    <Modal
      title="Cancel Policy"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      <div>
        {current === 1 && <></>}
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {display[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully Canceled Policy.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg || "Error occurred, please try again."}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CancelPolicyModal;
